module.exports = __webpack_public_path__ + "img/59.49db27e5.png";